import type { ChatbotState, CxJsonData, SetConversationVariableMetadata } from './types';
import { ChatbotStateScheme, CxJsonDataScheme, SetConversationVariableMetadataScheme } from './types';

export const isCxJsonData = (data: unknown): data is CxJsonData => CxJsonDataScheme.safeParse(data).success;
export const isSetConversationVariableMetadata = (data: unknown): data is SetConversationVariableMetadata => SetConversationVariableMetadataScheme.safeParse(data).success;
export const isChatbotState = (data: unknown): data is ChatbotState => ChatbotStateScheme.safeParse(data).success;
